import React from 'react';
import PropTypes from 'prop-types';
import { Download, FileText } from 'lucide-react';

/**
 * Embedded agreement PDF viewer with optional download link.
 * Registration flow passes showDownload={false}; Profile keeps its own download UX.
 */
export function AgreementPdfEmbed({
  previewUrl,
  title = 'Agreement PDF',
  height = 420,
  testId = 'dsa-agreement-pdf-preview',
}) {
  if (!previewUrl) return null;
  return (
    <iframe
      src={previewUrl}
      title={title}
      className="w-full border-0"
      style={{ height: `${height}px` }}
      data-testid={testId}
    />
  );
}

AgreementPdfEmbed.propTypes = {
  previewUrl: PropTypes.string,
  title: PropTypes.string,
  height: PropTypes.number,
  testId: PropTypes.string,
};

export function AgreementDocumentMeta({
  documentName,
  version,
  previewUrl,
  showDownload = false,
  downloadTestId = 'dsa-download-agreement-btn',
}) {
  if (!documentName) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
      <FileText className="w-3.5 h-3.5 text-emerald-600" />
      <span className="truncate">{documentName}</span>
      {version != null && <span>· Version {version}</span>}
      {showDownload && previewUrl && (
        <a
          href={previewUrl}
          target="_blank"
          rel="noreferrer"
          className="text-[#0066CC] hover:underline inline-flex items-center gap-1"
          data-testid={downloadTestId}
        >
          <Download className="w-3.5 h-3.5" /> Download
        </a>
      )}
    </div>
  );
}

AgreementDocumentMeta.propTypes = {
  documentName: PropTypes.string,
  version: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previewUrl: PropTypes.string,
  showDownload: PropTypes.bool,
  downloadTestId: PropTypes.string,
};

/** Registration agreement step must not expose a Download control. */
export const REGISTRATION_AGREEMENT_SHOW_DOWNLOAD = false;
